import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageService } from '../Services/page';
import { FlatPage } from '../Models/flatpage';


@Component({
  selector: 'page',
  templateUrl: '../Templates/page.html',
})


export class PageComponent implements OnInit {

  @Input()
  page_id: string;

  @Input()
  show_title: boolean = true;

  page: FlatPage;
  id: string;

  constructor(private route: ActivatedRoute,
              private pageService: PageService) {}

  ngOnInit() {

    if (this.page_id) {
      this.pageService.get(this.page_id).subscribe(
        page => { this.page = page }
      );
    } else {
      this.route.params.subscribe(params => {
        this.id = params['id'];

        this.pageService.get(this.id).subscribe(
          page => { this.page = page }
        );
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/page.ts